import Axios from "axios";
import React, { Component } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    NavLink,
    useParams,
    useRouteMatch,
    useHistory,
    Redirect,
} from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import { QRCode } from "react-qrcode-logo";
import { Player } from "video-react";
import hoistStatics from "hoist-non-react-statics";
import Func from "../../functions";
import Loading from "../../layouts/Loading";
import Env from "../../env";
import { toPng } from "html-to-image";

let checkVideoStyle = null;
class SbcqrmMix extends Component {
    constructor(props) {
        super(props);
        this.state = {
            qrCodeId: Date.now().toString(),
            videoUrl:
                "https://www.youtube.com/embed/CzOvi0vi5K8?si=DBUYPJzR6HjfB8w9",
            pageStatus: "Working",
            imageContent: null,
        };
    }

    componentDidMount = async () => {
        this.props.i18n.changeLanguage(this.props.lngName);
        // setTimeout(() => this.changePageToImage(), 1500);
    };

    componentWillUnmount = () => {
        clearInterval(checkVideoStyle);
        checkVideoStyle = null;
    };

    setLoading = (v) => {
        this.setState({ isLoading: v });
    };

    copyClick = (element) => {
        $("#" + element).trigger("click");
    };

    imageClick = async (e) => {
        let base64url = this.props.data.detail.qrcode;
        let fileFullName = "QrCode-" + this.props.data.cashierNo + ".png";

        if (this.isIphone()) {
            let blob = await (await fetch(base64url)).blob();
            let file = new File([blob], fileFullName, {
                type: "image/png",
            });

            if (navigator.canShare({ files: [file] })) {
                try {
                    await navigator.share({
                        title: "QRPH-" + this.props.data.cashierNo,
                        text: "QRPH-" + this.props.data.cashierNo,
                        files: [file],
                    });
                    Func.swalAlert("Success", "", "success");
                } catch (err) {}
            } else {
                Func.swalAlert(
                    "Info",
                    this.props.t("Cashier.QrCodeShareUnsupport") + ".",
                    "info"
                );
            }
        } else if (this.isAndroid()) {
            let a = document.createElement("a");
            a.href = base64url;
            a.download = fileFullName;
            a.click();
            Func.swalAlert("Success", "", "success");
        }
    };

    showVideo = () => {
        if (this.state.videoUrl !== "") {
            let styles = {
                rowMarginBottom: {
                    marginBottom: "0.5rem",
                },
            };
            // checkVideoStyle = setInterval(() => {
            //     if ($(".video-react-controls-enabled").length > 0) {
            //         $(".video-react-controls-enabled").css(
            //             "padding-top",
            //             "100%"
            //         );
            //         clearInterval(checkVideoStyle);
            //         checkVideoStyle = null;
            //         return;
            //     }
            // }, 1000);
            return (
                <div class="modal fade" id="qrCodeVideo" aria-hidden="true">
                    <div class="modal-dialog modal-xl">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title">
                                    {this.props.t("Cashier.QrCodeTeachVideo")}
                                </h4>
                                <button
                                    type="button"
                                    class="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div
                                    className="form-group row"
                                    style={styles.rowMarginBottom}
                                >
                                    <div className="col-sm-12">
                                        <iframe
                                            width="100%"
                                            height="360px"
                                            src="https://www.youtube.com/embed/CzOvi0vi5K8?si=iCVYta2Elgrsvx5K"
                                            title="YouTube video player"
                                            frameborder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            allowfullscreen
                                        ></iframe>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer justify-content-between">
                                <button
                                    type="button"
                                    class="btn btn-default"
                                    data-dismiss="modal"
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return "";
    };

    isIphone = () => {
        let nua = navigator.userAgent;

        if (nua.includes("iPhone")) {
            return true;
        }

        return false;
    };

    isAndroid = () => {
        let nua = navigator.userAgent;

        if (nua.includes("Android")) {
            return true;
        }

        return false;
    };

    changePageToImage = async () => {
        let node = document.getElementById("htmlChgContent");
        toPng(node, { cacheBust: true })
            .then((dataUrl) => {
                // Func.showLog(dataUrl);
                // imageContent = dataUrl;
                this.setState({
                    pageStatus: "Success",
                    imageContent: dataUrl,
                });
                // var img = new Image();
                // img.src = dataUrl;
                // img.width = 340;
                // document.body.appendChild(img);
            })
            .catch((err) => {
                Func.showLog(err);
                this.setState({ pageStatus: "Error3" });
            });
    };

    openGCashAppConfirm = () => {
        // Func.swalConfirm(
        //     "Question",
        //     "Do you want to open GCash APP?",
        //     "question",
        //     () => this.openGCashApp(),
        //     () =>
        //         Func.swalAlert(
        //             this.props.t("Conversation.Title.Warning"),
        //             this.props.t("Conversation.Content.AlreadyCancelRequest"),
        //             "warning"
        //         )
        // );
        this.openGCashApp();
    };

    openGCashApp = () => {
        if (this.props.data.detail.hasOwnProperty("extend2")) {
            setTimeout(() => {
                // window.location = this.props.data.detail.extend2;
                window.open(this.props.data.detail.extend2, "_blank", "popup");
            }, 100);
        } else if (this.props.data.detail.hasOwnProperty("extend")) {
            setTimeout(() => {
                // window.location = this.props.data.detail.extend;
                window.open(this.props.data.detail.extend, "_blank", "popup");
            }, 100);
        }
    };

    render() {
        let showPostScriptStyle = this.props.styles.displayNormal;
        if (!this.props.data.detail.postscript) {
            showPostScriptStyle = this.props.styles.displayNone;
        }
        // let showPayerNameStyle = this.props.styles.displayNormal;
        let showPayerNameStyle = this.props.styles.displayNone;
        if (!this.props.data.payerName) {
            showPayerNameStyle = this.props.styles.displayNone;
        }

        let inputEndRadius = this.props.styles.inputEndRadius;

        let grabMixStyle = {
            tagLabel: {
                color: "#000",
            },
            tagBtnMemoBgColor: {
                background: "#fff",
            },
            tagContentTextShadow: {
                textShadow: "#dc3545 0px 0px 0px",
            },
            tagContentTextShadow3: {
                textShadow: "#dc3545 0px 0px 0px",
                fontWeight: "bolder",
            },
            qrCodeExtendBtn: {
                height: "unset",
            },
            qrBtnMarginTopBottom: {
                marginTop: "0.1rem",
                marginBottom: "0.1rem",
            },
            qrBtnDisplayNone: {
                display: "none",
            },
            tagContentTextShadow2: {
                textShadow: "#dc3545 0px 0px 0px",
                justifyContent: "center",
            },
            ePaysIcon: {
                width: "1.5rem",
                margin: "2px",
            },
            pageImgStyle: {
                width: "100%",
            },
        };

        let isPhone = false;
        let qrBtnSet = 12;
        if (this.isIphone() || this.isAndroid()) {
            isPhone = true;
            qrBtnSet = 6;
        }

        if (
            this.state.pageStatus === "Success" &&
            this.state.imageContent != null
        ) {
            return (
                <div>
                    <img
                        id="divWiImage"
                        src={this.state.imageContent}
                        style={grabMixStyle.pageImgStyle}
                    />
                </div>
            );
        }

        return (
            <div id="htmlChgContent">
                {Env.showQrCode == "Y" &&
                this.props.data.detail.qrcode &&
                this.props.data.detail.qrcode != "" ? (
                    <div
                        className="form-group row"
                        style={this.props.styles.rowMarginBottom}
                    >
                        <label
                            className="col-sm-12 col-form-label text-sm"
                            style={grabMixStyle.tagLabel}
                        >
                            {this.props.t("Cashier.QrCode")}
                        </label>
                        <div
                            className={"col-sm-" + qrBtnSet}
                            // style={
                            //     isPhone
                            //         ? this.props.styles.rowMarginBottom
                            //         : grabMixStyle.qrBtnDisplayNone
                            // }
                            style={grabMixStyle.qrBtnDisplayNone}
                        >
                            <button
                                type="button"
                                class="btn btn-block btn-info btn-xs"
                                style={grabMixStyle.qrBtnMarginTopBottom}
                                onClick={() => this.openGCashAppConfirm()}
                            >
                                OPEN in GCash
                            </button>
                        </div>
                        {/* <div
                            className={"col-sm-" + qrBtnSet}
                            // style={this.props.styles.rowMarginBottom}
                            style={grabMixStyle.qrBtnDisplayNone}
                        >
                            <button
                                type="button"
                                class="btn btn-block btn-warning btn-xs"
                                style={grabMixStyle.qrBtnMarginTopBottom}
                                data-toggle="modal"
                                data-target={
                                    this.state.videoUrl === ""
                                        ? ""
                                        : "#qrCodeVideo"
                                }
                            >
                                {this.props.t("Cashier.QrCodeTeachVideo")}
                            </button>
                        </div> */}
                        <div
                            id={"qr_" + this.state.qrCodeId + "_code_f"}
                            className="input-group col-sm-12"
                            style={this.props.styles.rowMarginBottomQrCode}
                        >
                            <QRCode
                                id={"qr_" + this.state.qrCodeId + "_code"}
                                value={this.props.data.detail.qrcode}
                                ecLevel="H"
                                size={
                                    $("#main_layout_card").width() * (70 / 100)
                                }
                                logoImage="/images/grab/grab-logo.png"
                                // qrStyle={this.props.styles.qrCode}
                            />
                            {/* <img
                                src={this.props.data.detail.qrcode}
                                alt={
                                    "QrCode-" +
                                    this.props.data.cashierNo +
                                    ".png"
                                }
                                style={this.props.styles.qrCode}
                            /> */}
                            <div
                                className="input-group text-danger text-sm"
                                style={grabMixStyle.tagContentTextShadow2}
                            >
                                <span class="badge bg-warning">NO FEES!</span>
                            </div>
                            <div
                                className="input-group text-danger text-sm"
                                style={grabMixStyle.tagContentTextShadow2}
                            >
                                <img
                                    src="/images/GCash2.png"
                                    style={grabMixStyle.ePaysIcon}
                                />
                                <img
                                    src="/images/maya3.png"
                                    style={grabMixStyle.ePaysIcon}
                                />
                                <img
                                    src="/images/BOPAY3.png"
                                    style={grabMixStyle.ePaysIcon}
                                />
                                <img
                                    src="/images/ShopeePay.png"
                                    style={grabMixStyle.ePaysIcon}
                                />
                            </div>
                            <div
                                className="input-group text-danger text-xs"
                                style={grabMixStyle.tagContentTextShadow3}
                            >
                                {this.props.t("Cashier.QrCodeUsingRule2")}
                            </div>
                        </div>
                    </div>
                ) : (
                    ""
                )}
                {/* <div className="form-group row" style={showPayerNameStyle}>
                    <label
                        className="col-sm-12 col-form-label text-sm"
                        style={grabMixStyle.tagLabel}
                    >
                        {this.props.t("Cashier.PayerPhoneNumber")}
                    </label>
                    <div
                        className="col-sm-12"
                        style={this.props.styles.rowMarginBottom}
                    >
                        <input
                            id="payerName"
                            name="payerName"
                            className="form-control form-control-sm"
                            style={this.props.styles.inputReadOnlyStyle}
                            value={this.props.payerName}
                            readOnly
                        />
                        <div
                            className="input-group text-danger text-xs"
                            style={grabMixStyle.tagContentTextShadow}
                        >
                            {this.props.t("Cashier.SbcQrmAccountInfoDesc")}
                        </div>
                    </div>
                </div> */}
                {/* <div className="form-group row" style={showPostScriptStyle}>
                    <label
                        className="col-sm-12 col-form-label text-sm"
                        style={grabMixStyle.tagLabel}
                    >
                        {this.props.t("Cashier.Postscript")}
                    </label>
                    <div
                        className="input-group col-sm-12"
                        style={this.props.styles.rowMarginBottom}
                    >
                        <input
                            id="postscript"
                            name="postscript"
                            className="form-control form-control-sm"
                            style={this.props.styles.inputReadOnlyStyle}
                            value={this.props.data.detail.postscript}
                            onClick={(e) => this.props.copyData(e)}
                            readOnly
                        />
                        <div
                            className="input-group-append"
                            style={grabMixStyle.tagBtnMemoBgColor}
                        >
                            <div
                                className="input-group-text text-xs"
                                style={inputEndRadius}
                                onClick={() => this.copyClick("postscript")}
                            >
                                <span className="fas text-xs">Copy</span>
                            </div>
                        </div>
                        <div
                            className="input-group text-danger text-xs"
                            style={grabMixStyle.tagContentTextShadow}
                        >
                            {this.props.t("Cashier.PostscriptContent")}
                        </div>
                    </div>
                </div> */}
                <div
                    className="form-group row"
                    style={this.props.styles.rowMarginBottom}
                >
                    <label
                        className="col-sm-12 col-form-label text-sm"
                        style={grabMixStyle.tagLabel}
                    >
                        {this.props.t("Cashier.Amount")}
                    </label>
                    {/* <div
                        className="input-group col-sm-12"
                        style={this.props.styles.rowMarginBottom}
                    > */}
                    <div
                        className="col-sm-12"
                        style={this.props.styles.rowMarginBottom}
                    >
                        <input
                            id="amount"
                            name="amount"
                            className="form-control form-control-sm"
                            style={this.props.styles.inputReadOnlyStyle}
                            value={this.props.data.amount}
                            // onClick={(e) => this.props.copyData(e)}
                            readOnly
                        />
                        {/* <div
                            className="input-group-append"
                            style={grabMixStyle.tagBtnMemoBgColor}
                        >
                            <div
                                className="input-group-text text-xs"
                                style={inputEndRadius}
                                onClick={() => this.copyClick("amount")}
                            >
                                <span className="fas text-xs">Copy</span>
                            </div>
                        </div> */}
                        <div
                            className="input-group text-danger text-xs"
                            style={grabMixStyle.tagContentTextShadow}
                        >
                            {/* {this.props.t("Cashier.AmountContent1")}
                            <br />
                            {this.props.t("Cashier.AmountContent2")} */}
                        </div>
                    </div>
                </div>
                {/* <div
                    className="form-group row"
                    style={this.props.styles.rowMarginBottom}
                >
                    <label
                        className="col-sm-12 col-form-label text-sm"
                        style={grabMixStyle.tagLabel}
                    >
                        {this.props.t("Cashier.ReceiveGCashAccount")}
                    </label>
                    <div
                        className="input-group col-sm-12"
                        style={this.props.styles.rowMarginBottom}
                    >
                        <input
                            id="card_no"
                            name="card_no"
                            className="form-control form-control-sm"
                            style={this.props.styles.inputReadOnlyStyle}
                            value={this.props.data.detail.phone_number}
                            onClick={(e) => this.props.copyData(e)}
                            readOnly
                        />
                        <div
                            className="input-group-append"
                            style={grabMixStyle.tagBtnMemoBgColor}
                        >
                            <div
                                className="input-group-text text-xs"
                                style={inputEndRadius}
                                onClick={() => this.copyClick("card_no")}
                            >
                                <span className="fas text-xs">Copy</span>
                            </div>
                        </div>
                        <div
                            className="input-group text-danger text-xs"
                            style={grabMixStyle.tagContentTextShadow}
                        >
                            {this.props.t("Cashier.CardNumberContent")}
                        </div>
                    </div>
                </div> */}
                <div
                    className="form-group row"
                    style={this.props.styles.rowMarginBottom}
                >
                    <label
                        className="col-sm-12 col-form-label text-sm"
                        style={grabMixStyle.tagLabel}
                    >
                        {this.props.t("Cashier.CashierQRTransUniNo")}
                    </label>
                    <div
                        className="col-sm-12"
                        style={this.props.styles.rowMarginBottom}
                    >
                        <input
                            id="cashierNo"
                            name="cashierNo"
                            className="form-control form-control-sm"
                            style={this.props.styles.inputReadOnlyStyle}
                            value={this.props.data.cashierNo}
                            readOnly
                        />
                        <div
                            className="input-group text-danger text-xs"
                            style={grabMixStyle.tagContentTextShadow}
                        >
                            {/* {this.props.t("Cashier.SbcQrmAccountInfoDesc")} */}
                        </div>
                    </div>
                </div>
                {this.showVideo()}
            </div>
        );
    }
}

export default hoistStatics(withTranslation()(SbcqrmMix), SbcqrmMix);
